import React, { useState } from "react";
import Layout from "../Layout";
import HomeAfterlogin from "../../component/HomeAfterlogin";
import { Link } from "react-router-dom";

const Account = () => {
  const [show, setShow] = useState([]);
  const handel = (key) => {
    if (show.includes(key)) {
      setShow((prev) => {
        return prev?.filter((res) => {
          return res != key;
        });
      });
    } else {
      setShow([...show, key]);
    }
  };
  return (
    <Layout>
      <div className="page-container v-card v-sheet theme--light">
        <div className="row">
          <div className="col col-12">
            <div className="member-balance">
              <HomeAfterlogin />
            </div>
          </div>
        </div>
        <div
          role="listbox"
          className="v-item-group theme--light v-list-item-group"
        >
          <div
            role="option"
            aria-selected="true"
            className="v-list-item v-list-item--link theme--light"
          >
            <div
              className={`v-list-group parentNav-list-group ${
                show.includes("history")
                  ? "v-list-group--active primary--text"
                  : ""
              }`}
            >
              <div
                onClick={() => handel("history")}
                role="button"
                className="v-list-group__header v-list-item v-list-item--link theme--light"
              >
                <div className="v-list-item__icon v-list-group__header__prepend-icon">
                  <span
                    aria-hidden="true"
                    width={24}
                    height={24}
                    className="v-icon notranslate parentNav-icon theme--light"
                    style={{
                      color: "rgb(0, 0, 0)",
                      "caret-color": "rgb(0, 0, 0)",
                    }}
                  >
                    <svg
                      data-v-4fbbc4aa
                      width={20}
                      height={18}
                      viewBox="0 0 20 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="v-icon__component theme--light"
                      style={{
                        color: "rgb(0, 0, 0)",
                        "caret-color": "rgb(0, 0, 0)",
                      }}
                    >
                      <path
                        data-v-4fbbc4aa
                        d="M13.6359 11.2678H11.9539C10.9124 11.2678 10.0311 10.3866 10.0311 9.34543V6.4011C10.0311 6.00053 10.2715 5.7605 10.6717 5.7605C11.0723 5.7605 11.3127 6.00052 11.3127 6.4011V9.34543C11.3127 9.746 11.5527 9.98603 11.9533 9.98603H13.6357C14.0362 9.98603 14.2766 10.2264 14.2766 10.6269C14.2766 11.0275 13.8763 11.2679 13.636 11.2679L13.6359 11.2678Z"
                        fill="#000000"
                      />
                      <path
                        data-v-4fbbc4aa
                        d="M11.1626 17.6747C10.2177 17.6747 9.28709 17.526 8.39675 17.2332C7.98935 17.099 7.7683 16.6602 7.90217 16.2533C8.03605 15.8462 8.47485 15.6242 8.8821 15.7587C9.61551 15.9999 10.3828 16.1223 11.1622 16.1223C15.1792 16.1223 18.447 12.8544 18.447 8.83743C18.4472 4.82045 15.1795 1.55261 11.1626 1.55261C7.14558 1.55261 3.87774 4.82049 3.87774 8.83743C3.87774 9.26623 3.53022 9.61374 3.10143 9.61374C2.67264 9.61374 2.32513 9.26622 2.32513 8.83743C2.32513 3.96458 6.28971 0 11.1626 0C16.0354 0 20 3.96458 20 8.83743C20 13.7103 16.0354 17.6749 11.1626 17.6749L11.1626 17.6747Z"
                        fill="#000000"
                      />
                      <path
                        data-v-4fbbc4aa
                        d="M3.08909 9.78857C2.47045 9.78857 1.99512 9.39603 1.77528 9.02969L0.109251 6.2291C-0.109992 5.86051 0.0111539 5.3841 0.37944 5.16503C0.748335 4.94608 1.22445 5.06693 1.44352 5.43521L3.10694 8.23111C3.10573 8.22807 3.10725 8.22898 3.10937 8.2302C3.11968 8.2261 3.13302 8.21989 3.15031 8.21033L6.03656 6.47549C6.40394 6.25473 6.88095 6.3736 7.102 6.74098C7.32276 7.10866 7.20389 7.58536 6.83651 7.80642L3.9272 9.5543C3.62835 9.72063 3.34649 9.78856 3.08903 9.78856L3.08909 9.78857Z"
                        fill="#000000"
                      />
                    </svg>
                  </span>
                </div>
                <div className="v-list-item__content parentNav-item-content">
                  <div className="v-list-item__title parentNav-title">
                    History
                  </div>
                </div>
                <div className="v-list-item__icon v-list-group__header__append-icon">
                  <i
                    aria-hidden="true"
                    className="v-icon notranslate mdi mdi-chevron-down theme--light"
                  />
                </div>
              </div>
              {show.includes("history") && (
                <div className="v-list-group__items" style={{}}>
                  <div>
                    <Link
                      to="/history/betting-history"
                      className="child-list-item v-list-item v-list-item--link theme--light"
                      role="option"
                      aria-selected="false"
                    >
                      <div className="v-list-group childNav-list-group v-list-group--no-action">
                        <div
                          role="button"
                          className="v-list-group__header v-list-item v-list-item--link theme--light"
                        >
                          <div
                            className="v-list-item__content"
                            style={{
                              "margin-left": "-8px",
                              padding: "8px 0px",
                            }}
                          >
                            <div className="v-list-item__title childNav-title">
                              Bet History
                            </div>
                          </div>
                          <div className="v-list-item__icon v-list-group__header__append-icon">
                            <i
                              aria-hidden="true"
                              className="v-icon notranslate mdi mdi-chevron-right theme--light"
                            />
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                  <div>
                    <Link
                      to="/history/transaction-history"
                      className="child-list-item v-list-item v-list-item--link theme--light"
                      role="option"
                      aria-selected="false"
                    >
                      <div className="v-list-group childNav-list-group v-list-group--no-action">
                        <div
                          role="button"
                          className="v-list-group__header v-list-item v-list-item--link theme--light"
                        >
                          <div
                            className="v-list-item__content"
                            style={{
                              "margin-left": "-8px",
                              padding: "8px 0px",
                            }}
                          >
                            <div className="v-list-item__title childNav-title">
                              Transaction History
                            </div>
                          </div>
                          <div className="v-list-item__icon v-list-group__header__append-icon">
                            <i
                              aria-hidden="true"
                              className="v-icon notranslate mdi mdi-chevron-right theme--light"
                            />
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                  <div>
                    <Link
                      to="/history/withdrawl-history"
                      className="child-list-item v-list-item v-list-item--link theme--light"
                      role="option"
                      aria-selected="false"
                    >
                      <div className="v-list-group childNav-list-group v-list-group--no-action">
                        <div
                          role="button"
                          className="v-list-group__header v-list-item v-list-item--link theme--light"
                        >
                          <div
                            className="v-list-item__content"
                            style={{
                              "margin-left": "-8px",
                              padding: "8px 0px",
                            }}
                          >
                            <div className="v-list-item__title childNav-title">
                              Withdrawl History
                            </div>
                          </div>
                          <div className="v-list-item__icon v-list-group__header__append-icon">
                            <i
                              aria-hidden="true"
                              className="v-icon notranslate mdi mdi-chevron-right theme--light"
                            />
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>{" "}
                  <div>
                    <Link
                      to="/history/deposit-history"
                      className="child-list-item v-list-item v-list-item--link theme--light"
                      role="option"
                      aria-selected="false"
                    >
                      <div className="v-list-group childNav-list-group v-list-group--no-action">
                        <div
                          role="button"
                          className="v-list-group__header v-list-item v-list-item--link theme--light"
                        >
                          <div
                            className="v-list-item__content"
                            style={{
                              "margin-left": "-8px",
                              padding: "8px 0px",
                            }}
                          >
                            <div className="v-list-item__title childNav-title">
                              Deposit History
                            </div>
                          </div>
                          <div className="v-list-item__icon v-list-group__header__append-icon">
                            <i
                              aria-hidden="true"
                              className="v-icon notranslate mdi mdi-chevron-right theme--light"
                            />
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div
            role="option"
            aria-selected="false"
            className="v-list-item v-list-item--link theme--light"
          >
            <div
              className={`v-list-group parentNav-list-group ${
                show.includes("special")
                  ? "v-list-group--active primary--text"
                  : ""
              }`}
            >
              <div
                onClick={() => handel("special")}
                role="button"
                className="v-list-group__header v-list-item v-item--active v-list-item--active v-list-item--link theme--light"
              >
                <div className="v-list-item__icon v-list-group__header__prepend-icon">
                  <span
                    aria-hidden="true"
                    width={24}
                    height={24}
                    className="v-icon notranslate parentNav-icon theme--light"
                    style={{
                      color: "rgb(0, 0, 0)",
                      "caret-color": "rgb(0, 0, 0)",
                    }}
                  >
                    <svg
                      data-v-67533088
                      width={21}
                      height={20}
                      viewBox="0 0 21 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="v-icon__component theme--light"
                      style={{
                        color: "rgb(0, 0, 0)",
                        "caret-color": "rgb(0, 0, 0)",
                      }}
                    >
                      <path
                        data-v-67533088
                        d="M3.44736 11.4561C3.34026 11.4561 3.27604 11.5416 3.27604 11.6274V12.6125C3.27604 12.6981 3.36162 12.7838 3.44736 12.7838H10.7707C11.0277 12.2913 11.3703 11.8416 11.7558 11.4562L3.44736 11.4561Z"
                        fill="#000000"
                      />
                      <path
                        data-v-67533088
                        d="M3.44736 8.05127C3.34026 8.05127 3.27604 8.13686 3.27604 8.2226V9.20769C3.27604 9.31479 3.36162 9.37901 3.44736 9.37901H13.5545C13.6616 9.37901 13.7258 9.29343 13.7258 9.20769V8.2226C13.7258 8.1155 13.6402 8.05127 13.5545 8.05127H3.44736Z"
                        fill="#000000"
                      />
                      <path
                        data-v-67533088
                        d="M10.1283 14.8608H1.99125C1.62724 14.8608 1.32748 14.561 1.32748 14.197V6.05994H15.653V9.74304H15.8457C16.2311 9.74304 16.6166 9.78591 16.9806 9.85014V3.55461C16.9806 3.06214 16.7879 2.59104 16.4667 2.24839V2.22703H16.4453C16.0813 1.82014 15.5459 1.56325 14.9677 1.56325H13.5117V0.663776C13.5117 0.299768 13.2119 0 12.8479 0H11.8415C11.4775 0 11.1777 0.29978 11.1777 0.663776V1.54176H5.78155V0.663776C5.78155 0.299768 5.48177 0 5.11778 0H4.11135C3.74734 0 3.44757 0.29978 3.44757 0.663776V1.54176H1.99154C1.41334 1.54176 0.878006 1.79868 0.513978 2.20554H0.492469V2.2269C0.19269 2.56955 0 3.04065 0 3.53311V14.1756C0 15.2891 0.899362 16.1669 1.99137 16.1669H10.1285C10.1071 15.9314 10.0856 15.7172 10.0856 15.4816C10.0857 15.2891 10.1071 15.0749 10.1285 14.8609L10.1283 14.8608Z"
                        fill="#000000"
                      />
                      <path
                        data-v-67533088
                        d="M15.8457 11.0063C13.3617 11.0063 11.3489 13.0192 11.3489 15.5032C11.3489 17.9871 13.3618 20 15.8457 20C18.3297 20 20.3425 17.9871 20.3425 15.5032C20.3425 13.0192 18.3296 11.0063 15.8457 11.0063ZM15.8457 18.6723C14.1113 18.6723 12.6766 17.259 12.6766 15.5032C12.6766 13.7472 14.0899 12.3341 15.8457 12.3341C17.6017 12.3341 19.0149 13.7474 19.0149 15.5032C19.015 17.259 17.6017 18.6723 15.8457 18.6723Z"
                        fill="#000000"
                      />
                      <path
                        data-v-67533088
                        d="M17.4303 14.7752L16.5952 14.6468C16.5309 14.6468 16.4881 14.6039 16.4452 14.5397L16.0598 13.7688C15.9743 13.5761 15.7172 13.5761 15.6101 13.7688L15.2461 14.5183C15.2247 14.5826 15.1605 14.6039 15.0961 14.6254L14.2397 14.7539C14.047 14.7752 13.9612 15.0323 14.1112 15.1821L14.7108 15.7603C14.7536 15.8032 14.775 15.8674 14.775 15.9316L14.625 16.7881C14.5822 16.9808 14.7964 17.1521 14.989 17.045L15.7387 16.6383C15.8029 16.6169 15.8672 16.6169 15.91 16.6383L16.6596 17.0452C16.8309 17.1307 17.0449 16.9809 17.0236 16.7882L16.8736 15.9531C16.8736 15.8889 16.8736 15.8247 16.9378 15.7818L17.5588 15.1822C17.7087 15.0536 17.623 14.7967 17.4303 14.7752V14.7752Z"
                        fill="#000000"
                      />
                    </svg>
                  </span>
                </div>
                <div className="v-list-item__content parentNav-item-content">
                  <div className="v-list-item__title parentNav-title">
                    Special
                  </div>
                </div>
                <div className="v-list-item__icon v-list-group__header__append-icon">
                  <i
                    aria-hidden="true"
                    className="v-icon notranslate mdi mdi-chevron-down theme--light"
                  />
                </div>
              </div>
              {show?.includes("special") && (
                <div className="v-list-group__items" style={{}}>
                  <div>
                    <Link
                      to="/refer"
                      className="child-list-item v-list-item v-list-item--link theme--light"
                      tabIndex={0}
                      role="option"
                      aria-selected="false"
                    >
                      <div className="v-list-group childNav-list-group v-list-group--no-action">
                        <div
                          tabIndex={0}
                          aria-expanded="false"
                          role="button"
                          className="v-list-group__header v-list-item v-list-item--link theme--light"
                        >
                          <div
                            className="v-list-item__content"
                            style={{
                              "margin-left": "-8px",
                              padding: "8px 0px",
                            }}
                          >
                            <div className="v-list-item__title childNav-title">
                              Refer and Earn
                            </div>
                          </div>
                          <div className="v-list-item__icon v-list-group__header__append-icon">
                            <i
                              aria-hidden="true"
                              className="v-icon notranslate mdi mdi-chevron-right theme--light"
                            />
                          </div>
                        </div>
                        {/**/}
                      </div>
                    </Link>
                  </div>
                  <div>
                    <Link
                      to="/affiliateLink"
                      role="option"
                      aria-selected="false"
                      className="child-list-item v-list-item v-list-item--link theme--light"
                    >
                      <div className="v-list-group childNav-list-group v-list-group--no-action">
                        <div
                          tabIndex={0}
                          aria-expanded="false"
                          role="button"
                          className="v-list-group__header v-list-item v-list-item--link theme--light"
                        >
                          <div
                            className="v-list-item__content"
                            style={{
                              "margin-left": "-8px",
                              padding: "8px 0px",
                            }}
                          >
                            <div className="v-list-item__title childNav-title">
                              Agent Affiliate
                            </div>
                          </div>
                          <div className="v-list-item__icon v-list-group__header__append-icon">
                            <i
                              aria-hidden="true"
                              className="v-icon notranslate mdi mdi-chevron-right theme--light"
                            />
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                  <div>
                    <Link
                      to="/rebate"
                      className="child-list-item v-list-item v-list-item--link theme--light"
                      tabIndex={0}
                      role="option"
                      aria-selected="false"
                    >
                      <div className="v-list-group childNav-list-group v-list-group--no-action">
                        <div
                          tabIndex={0}
                          aria-expanded="false"
                          role="button"
                          className="v-list-group__header v-list-item v-list-item--link theme--light"
                        >
                          <div
                            className="v-list-item__content"
                            style={{
                              "margin-left": "-8px",
                              padding: "8px 0px",
                            }}
                          >
                            <div className="v-list-item__title childNav-title">
                              Rebate
                            </div>
                          </div>
                          <div className="v-list-item__icon v-list-group__header__append-icon">
                            <i
                              aria-hidden="true"
                              className="v-icon notranslate mdi mdi-chevron-right theme--light"
                            />
                          </div>
                        </div>
                        {/**/}
                      </div>
                    </Link>
                  </div>
                  <div>
                    <Link
                      to="/vip"
                      className="child-list-item v-list-item v-list-item--link theme--light"
                      tabIndex={0}
                      role="option"
                      aria-selected="false"
                    >
                      <div className="v-list-group childNav-list-group v-list-group--no-action">
                        <div
                          tabIndex={0}
                          aria-expanded="false"
                          role="button"
                          className="v-list-group__header v-list-item v-list-item--link theme--light"
                        >
                          <div
                            className="v-list-item__content"
                            style={{
                              "margin-left": "-8px",
                              padding: "8px 0px",
                            }}
                          >
                            <div className="v-list-item__title childNav-title">
                              VIP
                            </div>
                          </div>
                          <div className="v-list-item__icon v-list-group__header__append-icon">
                            <i
                              aria-hidden="true"
                              className="v-icon notranslate mdi mdi-chevron-right theme--light"
                            />
                          </div>
                        </div>
                        {/**/}
                      </div>
                    </Link>
                  </div>
                </div>
              )}
            </div>
          </div>
          {/* <div
            role="option"
            aria-selected="false"
            className="v-list-item v-list-item--link theme--light"
          >
            <div className="v-list-group parentNav-list-group">
              <div
                role="button"
                className="v-list-group__header v-list-item v-list-item--link theme--light"
              >
                <div className="v-list-item__icon v-list-group__header__prepend-icon">
                  <span
                    aria-hidden="true"
                    width={24}
                    height={24}
                    className="v-icon notranslate parentNav-icon theme--light"
                    style={{
                      color: "rgb(0, 0, 0)",
                      "caret-color": "rgb(0, 0, 0)",
                    }}
                  >
                    <svg
                      data-v-6abc8692
                      width={20}
                      height={20}
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="v-icon__component theme--light"
                      style={{
                        color: "rgb(0, 0, 0)",
                        "caret-color": "rgb(0, 0, 0)",
                      }}
                    >
                      <path
                        data-v-6abc8692
                        d="M5.60929 0C4.30805 0 3.25002 1.07334 3.25002 2.35944C3.25002 2.67404 3.31611 2.97381 3.42963 3.25002H0.750059C0.724076 3.24862 0.697917 3.24862 0.671935 3.25002C0.486914 3.26937 0.315492 3.35691 0.191314 3.49555C0.0671546 3.63401 -0.00103281 3.81398 1.18275e-05 4.00006V8.50002C1.18275e-05 8.69899 0.0790066 8.88977 0.219738 9.03032C0.36029 9.17105 0.551069 9.25005 0.750045 9.25005H1.50008V19.25C1.50008 19.4489 1.57908 19.6397 1.71964 19.7803C1.86036 19.921 2.05114 20 2.24994 20H17.7498C17.9486 20 18.1394 19.921 18.2801 19.7803C18.4207 19.6397 18.4997 19.4489 18.4997 19.25V9.25005H19.2497C19.4487 9.25005 19.6395 9.17106 19.78 9.03032C19.9207 8.88977 19.9997 8.69899 19.9997 8.50002V4.00006C19.9997 3.80108 19.9207 3.6103 19.78 3.46975C19.6395 3.32902 19.4487 3.25002 19.2497 3.25002H16.5701C16.6837 2.9738 16.7497 2.67404 16.7497 2.35945C16.7497 1.07334 15.6918 4.42774e-06 14.3905 4.42774e-06C13.0897 4.42774e-06 12.1284 0.629017 11.4218 1.30477C10.8885 1.8145 10.449 2.34307 9.99981 2.76561C9.55061 2.34307 9.11115 1.8145 8.57786 1.30477C7.87125 0.629017 6.90988 4.42774e-06 5.60913 4.42774e-06L5.60929 0ZM5.60929 1.50008C6.4641 1.50008 6.95883 1.83577 7.53905 2.39065C7.80202 2.64211 8.06395 2.9398 8.35149 3.25002H5.52348C5.48582 3.23101 5.44658 3.21549 5.4063 3.20311C5.02823 3.0976 4.74992 2.75182 4.74992 2.35945C4.74992 1.85986 5.09764 1.50009 5.60929 1.50009V1.50008ZM14.3905 1.50008C14.9021 1.50008 15.2498 1.85983 15.2498 2.35944C15.2498 2.75181 14.9715 3.09761 14.5935 3.2031C14.5506 3.21496 14.5087 3.23065 14.4686 3.25001H11.6483C11.9358 2.93978 12.1978 2.64211 12.4607 2.39064C13.0409 1.83573 13.5356 1.50007 14.3905 1.50007L14.3905 1.50008ZM1.49995 4.74992H9.24988V7.75002H1.49995V4.74992ZM10.7499 4.74992H18.4998V7.75002H10.7499V4.74992ZM2.99993 9.24988H9.24988V18.4998H2.99993V9.24988ZM10.7499 9.24988H16.9998V18.4998H10.7499V9.24988Z"
                        fill="#000000"
                      />
                    </svg>
                  </span>
                </div>
                <div className="v-list-item__content parentNav-item-content">
                  <div className="v-list-item__title parentNav-title">
                    Rewards
                  </div>
                </div>
                <div className="v-list-item__icon v-list-group__header__append-icon">
                  <i
                    aria-hidden="true"
                    className="v-icon notranslate mdi mdi-chevron-down theme--light"
                  />
                </div>
              </div>
            </div>
          </div> */}

          <div
            role="option"
            aria-selected="false"
            className="v-list-item v-list-item--link theme--light"
          >
            <div
              className={`v-list-group parentNav-list-group no-border ${
                show.includes("setting")
                  ? "v-list-group--active primary--text"
                  : ""
              }`}
            >
              <div
                onClick={() => handel("setting")}
                role="button"
                className="v-list-group__header v-list-item v-list-item--link theme--light"
              >
                <div className="v-list-item__icon v-list-group__header__prepend-icon">
                  <span
                    aria-hidden="true"
                    width={24}
                    height={24}
                    className="v-icon notranslate parentNav-icon theme--light"
                    style={{
                      color: "rgb(0, 0, 0)",
                      "caret-color": "rgb(0, 0, 0)",
                    }}
                  >
                    <svg
                      data-v-1f985d72
                      width={21}
                      height={20}
                      viewBox="0 0 21 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="v-icon__component theme--light"
                      style={{
                        color: "rgb(0, 0, 0)",
                        "caret-color": "rgb(0, 0, 0)",
                      }}
                    >
                      <path
                        data-v-1f985d72
                        d="M20.0008 11.8533L20.0001 7.99653C20.0001 7.57825 19.6619 7.24001 19.2436 7.24001L17.6034 7.23984C17.5217 7.01221 17.4302 6.79046 17.3304 6.57483L18.4901 5.41507C18.6323 5.27288 18.7119 5.08138 18.7119 4.88027C18.7119 4.67898 18.6325 4.48681 18.4901 4.34547L15.6547 1.51155C15.371 1.22785 14.8679 1.22785 14.5849 1.51155L13.4252 2.67132C13.2095 2.57067 12.988 2.47915 12.761 2.39826V0.756521C12.761 0.338238 12.4221 0 12.0045 0H7.99714C7.57953 0 7.24062 0.338238 7.24062 0.756521V2.3967C7.01366 2.47911 6.79193 2.56996 6.57496 2.67128L5.41671 1.51151C5.27452 1.37 5.08235 1.28979 4.88191 1.28979C4.68147 1.28979 4.48845 1.36916 4.34712 1.51151L1.51237 4.34544C1.37001 4.48763 1.29065 4.6798 1.29065 4.88024C1.29065 5.08068 1.37001 5.2737 1.51237 5.41503L2.67131 6.5748C2.57067 6.79044 2.47915 7.01198 2.39826 7.2398H0.756521C0.338913 7.2398 0 7.57804 0 7.99633V12.0037C0 12.4204 0.338913 12.7602 0.756521 12.7602H2.39739C2.47828 12.9865 2.57065 13.208 2.67045 13.4252L1.51068 14.5835C1.3685 14.7256 1.28896 14.9187 1.28896 15.1183C1.28896 15.3195 1.36833 15.5117 1.51068 15.6546L4.34612 18.4885C4.48831 18.6292 4.67981 18.7087 4.88092 18.7087C5.08221 18.7087 5.27438 18.6293 5.41571 18.487L6.57311 17.3287C6.79027 17.4309 7.01267 17.5224 7.23876 17.6033L7.23808 19.2435C7.23808 19.4448 7.31745 19.6369 7.4598 19.7783C7.60199 19.9198 7.79416 20 7.9946 20H12.0035C12.4211 20 12.76 19.6618 12.76 19.2435V17.6033C12.9869 17.5224 13.2087 17.43 13.4256 17.3287L14.5839 18.4885C14.7261 18.6307 14.9176 18.7102 15.1187 18.7102C15.32 18.7102 15.5122 18.6308 15.6535 18.4885L18.4882 15.653C18.7841 15.3572 18.7841 14.8791 18.4882 14.5833L17.3293 13.425C17.4299 13.2094 17.5215 12.9878 17.6032 12.76H19.2434H19.251C19.6936 12.7555 20.0158 12.4248 20.0158 12.0035C20.0159 11.9522 20.0107 11.9024 20.0007 11.8532L20.0008 11.8533ZM17.0534 11.2472C16.7152 11.2472 16.4186 11.472 16.3264 11.7972C16.1834 12.295 15.9882 12.7694 15.7454 13.2035C15.5812 13.4994 15.6326 13.867 15.8717 14.1061L16.8839 15.1183L15.1197 16.8848L14.1075 15.8711C13.8684 15.6335 13.5001 15.5798 13.2042 15.7455C12.7662 15.9907 12.2934 16.1857 11.7986 16.325C11.4734 16.418 11.2479 16.7154 11.2479 17.0535V18.4879H8.75292V17.0535C8.75292 16.7153 8.52816 16.4181 8.20226 16.325C7.70832 16.1858 7.23551 15.9913 6.7966 15.7455C6.6816 15.6804 6.55444 15.6494 6.42898 15.6494C6.23225 15.6494 6.03856 15.7265 5.89267 15.8711L4.882 16.8833L3.11598 15.1191L4.12902 14.1069C4.36729 13.8678 4.41948 13.4995 4.25534 13.2043C4.01251 12.7687 3.81729 12.2958 3.6758 11.798C3.58343 11.4728 3.28623 11.248 2.94798 11.248H1.51297V8.7537H2.94733C3.28557 8.7537 3.58277 8.52894 3.67515 8.20217C3.81582 7.70741 4.01035 7.23456 4.25469 6.79738C4.42035 6.50152 4.36817 6.13237 4.12906 5.89327L3.11756 4.88022L4.88186 3.11606L5.89404 4.12975C6.13315 4.36735 6.50077 4.41953 6.79733 4.25539C7.23386 4.01172 7.70736 3.81669 8.20299 3.67434C8.52907 3.58281 8.75365 3.28544 8.75365 2.94739V1.51302H11.248V2.94739C11.248 3.28562 11.4734 3.58433 11.7986 3.67589C12.2934 3.81656 12.7662 4.01109 13.2034 4.25543C13.4993 4.42109 13.8684 4.36891 14.1067 4.1298L15.1198 3.1161L16.8854 4.88027L15.8717 5.89396C15.6326 6.13307 15.5804 6.5029 15.7461 6.79656C15.9883 7.23223 16.1833 7.70507 16.3256 8.20286C16.4187 8.5281 16.7161 8.75288 17.0535 8.75288H18.4878L18.4885 11.2472H17.0534Z"
                        fill="#000000"
                      />
                      <path
                        data-v-1f985d72
                        d="M10 5.94995C7.76675 5.94995 5.94958 7.7656 5.94958 10.0004C5.94958 12.2328 7.76593 14.0508 10 14.0508C12.2339 14.0508 14.0504 12.2336 14.0504 10.0004C14.0504 7.76642 12.2333 5.94995 10 5.94995ZM10 12.5377C8.60113 12.5377 7.46263 11.3999 7.46263 10.0004C7.46263 8.6008 8.60113 7.46299 10 7.46299C11.3989 7.46299 12.5374 8.6008 12.5374 10.0004C12.5374 11.3999 11.3989 12.5377 10 12.5377Z"
                        fill="#000000"
                      />
                    </svg>
                  </span>
                </div>
                <div className="v-list-item__content parentNav-item-content">
                  <div className="v-list-item__title parentNav-title">
                    Settings
                  </div>
                </div>
                <div className="v-list-item__icon v-list-group__header__append-icon">
                  <i
                    aria-hidden="true"
                    className="v-icon notranslate mdi mdi-chevron-down theme--light"
                  />
                </div>
              </div>{" "}
              {show.includes("setting") && (
                <div className="v-list-group__items" style={{}}>
                  {/* <div>
                    <Link
                      to="/profile"
                      className="child-list-item v-list-item v-list-item--link theme--light"
                      tabIndex={0}
                      role="option"
                      aria-selected="false"
                    >
                      <div className="v-list-group childNav-list-group v-list-group--no-action">
                        <div
                          tabIndex={0}
                          aria-expanded="false"
                          role="button"
                          className="v-list-group__header v-list-item v-list-item--link theme--light"
                        >
                          <div
                            className="v-list-item__content"
                            style={{
                              "margin-left": "-8px",
                              padding: "8px 0px",
                            }}
                          >
                            <div className="v-list-item__title childNav-title">
                              Profile
                            </div>
                          </div>
                          <div className="v-list-item__icon v-list-group__header__append-icon">
                            <i
                              aria-hidden="true"
                              className="v-icon notranslate mdi mdi-chevron-right theme--light"
                            />
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div> */}
                  <div>
                    <Link
                      to="/change-password"
                      className="child-list-item v-list-item v-list-item--link theme--light"
                      tabIndex={0}
                      role="option"
                      aria-selected="false"
                    >
                      <div className="v-list-group childNav-list-group v-list-group--no-action">
                        <div
                          tabIndex={0}
                          aria-expanded="false"
                          role="button"
                          className="v-list-group__header v-list-item v-list-item--link theme--light"
                        >
                          <div
                            className="v-list-item__content"
                            style={{
                              "margin-left": "-8px",
                              padding: "8px 0px",
                            }}
                          >
                            <div className="v-list-item__title childNav-title">
                              Change password
                            </div>
                          </div>
                          <div className="v-list-item__icon v-list-group__header__append-icon">
                            <i
                              aria-hidden="true"
                              className="v-icon notranslate mdi mdi-chevron-right theme--light"
                            />
                          </div>
                        </div>
                        {/**/}
                      </div>
                    </Link>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Account;
